import React, {Component} from 'react';
import {Row, Col } from "reactstrap";
import {inject, observer} from "mobx-react/index";
import Popup from '../../comum/components/Popup';
import CardDetalheMobile from './CardDetalheMobile';

@inject("store")
@observer
export default class DetalhesProgramacaoMobile extends Component {
    constructor(props) {        
        super(props);

        this.state = {
            popupOpen: false
        }

        this.openPopUp = this.openPopUp.bind(this)
    }

    openPopUp() {
        this.setState({
            popupOpen: !this.state.popupOpen
        })
    }

    render() {
        // Criado um vetor de ids para as colunas que estão presentes. className="container-card-detalhe"
        const colunaId = this.props.colunas.map(col => col.id);
        return(
            <Col xs={12}>
                <div className="container-card-mobile--detalhe">
                    <Row className="m-0 no-gutters">
                        { this.props.campos.map((el, index) => {
                            if(colunaId.indexOf(el.id) === -1){
                                /**
                                 * Como é um componente específico para o projeto é adicionado uma verificação para caso o CardDetalhe seja do tipo
                                 * MOVS** para poder então abrir o pop-up desejado.
                                 */
                                if(el.movs){
                                    const desc = el.field.map((field) => this.props.row[field])
                                    return (
                                        <Col sm={4} key={index}>
                                            <CardDetalheMobile icone={el.icone}
                                                        titulo={el.titulo}
                                                        label={el.label}
                                                        desc={el.field.map((field) => this.props.row[field])}
                                                        formatacao={el.formatacao}
                                                        onClick={this.openPopUp}
                                                        hasPopUp={true}
                                            />
                                                <Popup
                                                    onClick={this.openPopUp}
                                                    isOpen={this.state.popupOpen}
                                                    title={<React.Fragment>
                                                        Movimentos de Operação - 
                                                        <span className="container-card-detalhe__detalhes-cod">{this.props.row.Viagem}</span>
                                                    </React.Fragment>}
                                                    information={desc}
                                                >
                                                    <div className="container-card-detalhe__detalhes-mov">
                                                        {this.props.dadosMov.map((elem,index) => 
                                                        {
                                                            if(elem.titulo === "Carga Geral" && !process.env.rig)
                                                                return null
                                                            return (
                                                                <div xs={4} key={index} className="container-card-detalhe__detalhes-mov--itens">
                                                                    <div>    
                                                                        <div className="container-card-detalhe__detalhes-mov--itens--title">
                                                                            {elem.titulo}
                                                                        </div>
                                                                        <div className="container-card-detalhe__detalhes-mov--itens--value">
                                                                            {elem.field.map((field) => this.props.row[field])}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                )
                                                        }
                                                        )}
                                                        </div>

                                                </Popup>
                                        </Col>)
                                }else{
                                    if(el.label === "Chegada na Barra" && process.env.rig){
                                        return null
                                    }else{
                                        return (
                                            <Col xs={4} sm={4} key={index}>
                                                <CardDetalheMobile icone={el.icone}
                                                        titulo={el.titulo}
                                                        label={el.label}
                                                        desc={el.field.map((field) => this.props.row[field])}
                                                        formatacao={el.formatacao}
                                                        hasPopUp={false}
                                                        />
                                            </Col>)
                                    }

                                }
                            }
                        })
                        }
                    </Row>
                </div>
                
                
            </Col>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/programacao/components/DetalhesProgramacaoMobile.js